import React from "react";
import { processSilentRenew } from "redux-oidc";

const component = () => {
  processSilentRenew();
  return <span>Am I silent?</span>;
};

export default component;
